import { hash } from "rsvp";
import Route from "@ember/routing/route";

export default class ServerCreateRoute extends Route {
  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  model() {
    let { project } = this.modelFor("organization");
    return hash({
      project,
      reservedIps: project.get("reservedIps").reload(),
      platformArguments: project.get("platformArguments"),
      serverTemplates: project.get("serverTemplates"),
    });
  }

  setupController(controller) {
    super.setupController(...arguments);
    controller.resetProperties();
    controller.setDefaultValues();
    controller.setTabs();
  }
}
